import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
};

export const Services = ({ onSelect }) => {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then(({ data }) => setServices(data)); }, []);

  return (
    <section id="services" className="py-24 lg:py-32 bg-[#0D0D0C]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="overline mb-4">Prestations & Tarifs</div>
        <h2 className="font-serif-d text-4xl lg:text-6xl tracking-tight max-w-2xl mb-16">Des formules pour chaque cuisine.</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {services.map((s, i) => (
            <motion.div key={s.id} data-testid={`service-card-${s.slug}`}
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group bg-[#161513] border border-[#F4F0EB]/8 p-8 lg:p-10 hover:border-[#C88D51]/40 transition-colors duration-500">
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h3 className="font-serif-d text-2xl lg:text-3xl">{s.name}</h3>
                  <div className="font-mono-a text-xs uppercase tracking-[0.2em] text-[#6E695E] mt-2">{s.duration}</div>
                </div>
                <div className="text-right">
                  <div className="font-mono-a text-[0.6rem] text-[#6E695E]">À PARTIR DE</div>
                  <div className="font-serif-d text-3xl text-[#C88D51]">{s.price_from}€</div>
                </div>
              </div>
              <p className="font-sub text-[#A39E93] text-sm leading-relaxed mb-6">{s.description}</p>
              <ul className="space-y-2 mb-8">
                {s.features.map((f) => (
                  <li key={f} className="flex items-center gap-3 font-sub text-sm text-[#F4F0EB]">
                    <Check className="w-4 h-4 text-[#C88D51]" /> {f}
                  </li>
                ))}
              </ul>
              <button data-testid={`service-book-${s.slug}`} onClick={() => { onSelect?.(s.slug); scrollTo("reservation"); }}
                className="font-sub text-sm flex items-center gap-2 text-[#F4F0EB] group-hover:text-[#C88D51] transition-colors link-u">
                Réserver cette prestation <ArrowUpRight className="w-4 h-4" />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
